"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MixpanelIntegration = void 0;

var _react = require("react");

var _index = require("../index");

var _mixpanel = require("../apis/mixpanel");

var _accountsClient = require("../apis/accountsClient");

const getUserInfo = profile => {
  const email = (profile === null || profile === void 0 ? void 0 : profile.email) || (profile === null || profile === void 0 ? void 0 : profile.sub);
  const name = profile === null || profile === void 0 ? void 0 : profile.name;
  const accountId = (profile || {})['https://claims.cimpress.io/account'];
  return {
    email,
    name,
    accountId
  };
};

const MixpanelIntegration = props => {
  const {
    accessToken,
    enabled,
    userProfile,
    mixpanelProjectId,
    applicationName,
    onLoad
  } = props;
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const [initializing, setInitializing] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!enabled || !accessToken || !userProfile) {
      return;
    }

    if (!initialized && !initializing) {
      const {
        email,
        name,
        accountId
      } = getUserInfo(userProfile);

      if (!email || !accountId) {
        return;
      }

      setInitializing(true);
      let accountInfo;

      try {
        const run = async () => {
          return await (0, _accountsClient.getAccount)(accessToken, accountId);
        };

        accountInfo = run();

        if (!accountInfo) {
          console.warn('Failed to initialize mixpanel, no account info');
          return;
        }
      } catch (e) {
        // we can't do much here...
        console.warn('Failed to initialize mixpanel...', e);
      }

      (0, _mixpanel.mxInit)(mixpanelProjectId !== null && mixpanelProjectId !== void 0 ? mixpanelProjectId : _index.MixpanelProductionProjectId, () => {
        (0, _mixpanel.mxUserProps)(email, {
          'Account ID': accountId,
          'Account Name': accountInfo.name,
          '$email': email,
          '$name': name
        });
        (0, _mixpanel.mxSuperProps)({
          'Application': applicationName,
          'User ID': email,
          'Account ID': accountId,
          'Account Name': accountInfo.name,
          '$email': email,
          '$name': name,
          'Email': email,
          'Name': name
        });
        setInitialized(true);
        setInitializing(false);

        if (onLoad) {
          onLoad();
        }
      });
    }
  }, [enabled, accessToken, userProfile]);
  return null;
};

exports.MixpanelIntegration = MixpanelIntegration;
MixpanelIntegration.defaultProps = {
  enabled: true,
  mixpanelProjectId: _index.MixpanelProductionProjectId
};